export default __webpack_public_path__ + "static/media/23.891a959f.png";